import React from "react";
import { InProgressSpinner } from "../shared/InProgressSpinner";

type GoogleSignInButtonProps = {
  onClick: () => void;
  isLoading: boolean;
  disabled?: boolean;
  label?: string;
};

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  onClick,
  isLoading,
  disabled,
  label = "Continue with Google",
}) => (
  <>
    <style>{`
      .auth-primary-button {
        position: relative;
        display: flex;
        min-height: 56px;
        width: 100%;
        align-items: center;
        justify-content: center;
        gap: 0.72rem;
        overflow: visible;
        border: 0;
        border-radius: 999px;
        font-size: 0.88rem;
        font-weight: 750;
        letter-spacing: 0;
      }

      .auth-primary-button > * {
        position: relative;
        z-index: 1;
      }

      .auth-primary-button span {
        text-shadow: 0 0 11px color-mix(in srgb, var(--fintheon-primary) 42%, transparent);
      }

      .auth-primary-button svg {
        filter: drop-shadow(0 0 5px color-mix(in srgb, var(--fintheon-primary) 30%, transparent));
      }

      .auth-primary-button:disabled {
        cursor: not-allowed;
        opacity: 0.58;
      }
    `}</style>
    <button
      onClick={onClick}
      disabled={disabled ?? isLoading}
      className="auth-primary-button fintheon-black-liquid-glass fintheon-primary-action"
      type="button"
    >
      {isLoading ? (
        <InProgressSpinner size={20} label="Starting Google sign in" />
      ) : (
        <>
          <svg aria-hidden="true" className="h-5 w-5" viewBox="0 0 24 24">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A11.96 11.96 0 001 12c0 1.94.46 3.77 1.18 5.42l3.66-2.84z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
          </svg>
          <span>{label}</span>
        </>
      )}
    </button>
  </>
);
